import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['overlay', 'panel', 'title', 'body'];
    static classes = ['open', 'show'];

    connect() {
        this._closeOverlaysHandler = () => {
            if (this.element.classList.contains(this.openClass)) this.close();
        };
        document.addEventListener('gymplus:ui:close-overlays', this._closeOverlaysHandler);
    }

    disconnect() {
        document.removeEventListener('gymplus:ui:close-overlays', this._closeOverlaysHandler);
    }

    open({ title, body } = {}) {
        if (title && this.hasTitleTarget) this.titleTarget.textContent = title;
        if (this.hasBodyTarget) this.bodyTarget.innerHTML = body || '';

        this.syncAgreeButtonsState();
        setTimeout(() => this.syncAgreeButtonsState(), 0);

        this.overlayTarget.classList.add(this.showClass);
        this.panelTarget.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => this.element.classList.add(this.openClass));
    }

    close() {
        this.element.classList.remove(this.openClass);
        this.panelTarget.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
            this.overlayTarget.classList.remove(this.showClass);
            if (this.hasBodyTarget) this.bodyTarget.innerHTML = '';
        }, 250);
    }

    toggleAgree(event) {
        const agree = event.currentTarget;
        const checked = agree.classList.toggle('panel-agree--checked');
        const targetId = agree.dataset.agreeFor;
        if (!targetId) return;

        const btn = this.bodyTarget.querySelector(`[data-agree-id="${targetId}"]`);
        if (btn) btn.disabled = !checked;
    }

    syncAgreeButtonsState() {
        if (!this.hasBodyTarget) return;

        this.bodyTarget.querySelectorAll('[data-agree-for]').forEach((agree) => {
            const targetId = agree.dataset.agreeFor;
            if (!targetId) return;

            const btn = this.bodyTarget.querySelector(`[data-agree-id="${targetId}"]`);
            if (!btn) return;

            const checked = agree.classList.contains('panel-agree--checked');
            btn.disabled = !checked;
        });
    }

    selectOption(event) {
        const option = event.currentTarget;
        const group = option.dataset.radioGroup;
        if (!group) return;

        const value = option.dataset.radioValue ?? '';
        const inputName = option.dataset.radioInput ?? '';

        this.bodyTarget
            .querySelectorAll(`[data-radio-group="${group}"]`)
            .forEach((el) => {
                el.classList.remove('panel-option--selected');
                el.setAttribute('aria-checked', 'false');
            });

        option.classList.add('panel-option--selected');
        option.setAttribute('aria-checked', 'true');

        if (inputName) {
            const hidden = this.bodyTarget.querySelector(`input[name="${inputName}"]`);
            if (hidden) hidden.value = value;
        }

        const toggleSelector = option.dataset.radioToggleTarget;
        if (toggleSelector) {
            const target = this.bodyTarget.querySelector(toggleSelector);
            if (target) {
                const show = option.dataset.radioToggleShow === '1';
                target.hidden = !show;

                target.querySelectorAll('input,select,textarea').forEach((field) => {
                    field.disabled = !show;
                });
            }
        }
    }

    formatIban(event) {
        const input = event.currentTarget;
        const raw = String(input.value || '')
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, '')
            .slice(0, 20);

        input.value = String(raw)
            .toUpperCase()
            .replace(/\s+/g, '')
            .replace(/[^A-Z0-9]/g, '');
    }
}
